import { useState } from "react";
import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { JobsList } from "@/components/jobs/JobsList";
import { QuickFilterTags } from "@/components/jobs/filters/QuickFilterTags";
import { JobFilters } from "@/components/jobs/filters/JobFiltersModal";
import { useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function CandidateJobs() {
  usePageMeta({
    title: "Vagas - Data Hire Club",
    description: "Vagas para candidatos",
    noindex: true,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState<JobFilters>({
    workType: [],
    contractType: [],
    seniority: [],
    salaryRanges: [],
    dataTags: [],
  });
  
  const location = useLocation();
  const isCommunityRoute = location.pathname.includes('/community');

  const handleQuickFilterClick = (tag: string) => {
    setFilters(prev => ({
      ...prev,
      dataTags: prev.dataTags.includes(tag)
        ? prev.dataTags.filter(t => t !== tag)
        : [...prev.dataTags, tag]
    }));
  };

  return (
    <CandidateLayout maxWidth="5xl">
      {!isCommunityRoute ? (
        <>
          <h1 className="text-xl md:text-2xl font-bold text-foreground mb-4 md:mb-6 text-center">
            Vagas Publicadas Recentemente
          </h1>

          <div className="max-w-2xl mx-auto mb-4 md:mb-6">
            <div className="relative mb-6">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
              <Input
                type="text"
                placeholder="Buscar vagas..."
                className="pl-10"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <QuickFilterTags
              selectedTags={filters.dataTags}
              onTagClick={handleQuickFilterClick}
            />
          </div>

          <JobsList searchQuery={searchQuery} filters={filters} />
        </>
      ) : (
        <div className="bg-card rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold text-foreground mb-6">
            {location.pathname.includes('introductions') && "Apresente-se"}
            {location.pathname.includes('learning') && "O que você está aprendendo"}
            {location.pathname.includes('questions') && "Tire suas dúvidas"}
            {location.pathname.includes('links') && "Links externos"}
          </h1>
          <p className="text-muted-foreground">
            Conteúdo em desenvolvimento. Em breve você poderá interagir com outros membros da comunidade aqui!
          </p>
        </div>
      )}
    </CandidateLayout>
  );
}
